import { Field, Int } from '@nestjs/graphql'
import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class UpdateCategoryDto extends BaseUpdateDto<UpdateCategoryDto> {
  @Field({nullable: true})
  name?: string

  @Field(t => Int, { nullable: true })
  parentCategoryId?: number | null

  @Field(t => Int, { nullable: true })
  sortOrder?: number | null
}
